import { InputLabel, MenuItem } from '@mui/material';
import { memo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { ItemVM } from 'shell/view-models/item';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';

const list = Object.freeze([
  {
    id: '1',
    value: 'Tutti',
  },
  {
    id: '2',
    value: 'In data diversa',
  },
  {
    id: '3',
    value: 'In mese diverso',
  },
]);

interface VoidServiceListProps {
  disabled?: boolean;
  value: string;
  onChange: (value: string) => void;
  error?: boolean;
  label?: string;
}

const VoidServiceListComponent = ({
  disabled,
  onChange,
  value,
  error,
  label = 'Servizi annullati',
}: VoidServiceListProps): React.ReactElement => {
  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id={`label-${label}`}>
        {label}
      </InputLabel>
      <PmiSelect
        labelId={`label-${label}`}
        id={`id-${label}`}
        name={`id-${label}`}
        value={value}
        label={label}
        onChange={(event) => onChange(event.target.value)}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {list.map((item: ItemVM) => (
          <MenuItem key={item.id} value={item.id}>
            {item.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

VoidServiceListComponent.displayName = 'Void Service list component';

const VoidServiceList = memo(VoidServiceListComponent);

export default VoidServiceList as typeof VoidServiceListComponent;
